/**
 * Brand Feature Input Interface - Domain layer
 * Defines the input structure for creating a Brand Feature entity
 */
interface IBrandFeature {
  brandFeatureId: number;
  brandFeatureKey: string;
  brandFeatureName: string;
  brandFeatureDescription: string | null;
  brandFeatureIsActive: boolean;
  brandFeatureIsMainMenu: boolean;
  brandFeatureMappingId: number | null;
  brandFeatureMappingCreatedAt: string | null;
  brandFeatureMappingCreatedBy: number | null;
}

/**
 * Brand Feature entity - Domain layer
 * Represents brand feature data from GraphQL API
 */
export class BrandFeature {
  private readonly _brandFeatureId: number;
  private readonly _brandFeatureKey: string;
  private readonly _brandFeatureName: string;
  private readonly _brandFeatureDescription: string | null;
  private readonly _brandFeatureIsActive: boolean;
  private readonly _brandFeatureIsMainMenu: boolean;
  private readonly _brandFeatureMappingId: number | null;
  private readonly _brandFeatureMappingCreatedAt: string | null;
  private readonly _brandFeatureMappingCreatedBy: number | null;

  constructor(props: IBrandFeature) {
    this._brandFeatureId = props.brandFeatureId;
    this._brandFeatureKey = props.brandFeatureKey;
    this._brandFeatureName = props.brandFeatureName;
    this._brandFeatureDescription = props.brandFeatureDescription;
    this._brandFeatureIsActive = props.brandFeatureIsActive;
    this._brandFeatureIsMainMenu = props.brandFeatureIsMainMenu;
    this._brandFeatureMappingId = props.brandFeatureMappingId;
    this._brandFeatureMappingCreatedAt = props.brandFeatureMappingCreatedAt;
    this._brandFeatureMappingCreatedBy = props.brandFeatureMappingCreatedBy;
  }

  get brandFeatureId(): number {
    return this._brandFeatureId;
  }
  get brandFeatureKey(): string {
    return this._brandFeatureKey;
  }
  get brandFeatureName(): string {
    return this._brandFeatureName;
  }
  get brandFeatureDescription(): string | null {
    return this._brandFeatureDescription;
  }

  get brandFeatureIsActive(): boolean {
    return this._brandFeatureIsActive;
  }
  get brandFeatureIsMainMenu(): boolean {
    return this._brandFeatureIsMainMenu;
  }
  get brandFeatureMappingId(): number | null {
    return this._brandFeatureMappingId;
  }
  get brandFeatureMappingCreatedAt(): string | null {
    return this._brandFeatureMappingCreatedAt;
  }
  get brandFeatureMappingCreatedBy(): number | null {
    return this._brandFeatureMappingCreatedBy;
  }
}
